var React = require('react');

function Eye (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8 48C8 48 20 20 48 20C76 20 88 48 88 48C88 48 76 76 48 76C20 76 8 48 8 48Z","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M48 60C54.6274 60 60 54.6274 60 48C60 41.3726 54.6274 36 48 36C41.3726 36 36 41.3726 36 48C36 54.6274 41.3726 60 48 60Z","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Eye.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Eye;

Eye.default = Eye;
